// extracted by mini-css-extract-plugin
export default {"Title":"RQDavCzh","title_20":"PF3GDX73","title_24":"mP_mBcwr","title_50":"x8GqrnNT","title_32":"CjzKieYm","title_36":"BzesMx_V","title_14_400":"m1hb3aEE","title_20_400":"aLYiS7IG","title_24_400":"XuXsAe3T","title_30_400":"ThzjZrBq","title_32_400":"N3NRSyhz","title_36_400":"fu9uvQsu","positionCenter":"Y56hxmxf"};
    if(module.hot) {
      // 1712151478368
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  